export const USER_PROFILE_TYPE = {
  PRIMARY: 'PRIMARY',
  ALTERNATIVE: 'ALTERNATIVE',
  WITHOUT_REGISTRATION: 'WITHOUT_REGISTRATION',
};
